import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { DeviceService } from '@omni/services/device/device.service';
import { EventsService } from '@omni/services/events/events.service';
import { ChildNavNames, NavigationService, PageName } from '@omni/services/navigation/navigation.service';
import { UIService } from '@omni/services/ui/ui.service';

@Component({
  selector: 'go-app-notification-page',
  templateUrl: './go-app-notification-page.html',
  styleUrl: './go-app-notification-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoAppNotificationPageComponent {

  @ViewChild('notificationrightpane', { static: true }) public navCtrl: IonNav;
  @Input() callback;
  @Input() __source = '';

  private rightPaneSub: Subscription;

  constructor(
    public navService: NavigationService,
    public device: DeviceService,
    private readonly events: EventsService,
    private readonly uiService: UIService,
    private readonly cdRef: ChangeDetectorRef,
  ) {

  }

  ngOnInit() {
    this.events.publish('clearSelectedView');
    // The left/right split here is `OnPush` and the mobile show/hide `[ngClass]`
    // reads `navService.isActiveChildNavRightPaneViewDisplayed` (a plain getter).
    // A detail view living inside the right-pane `<ion-nav>` (e.g. the SDR detail
    // opened from a notification) toggles that flag when it closes, but that
    // mutation can't mark this host for check — so the pane would stay open over
    // the list. Re-check whenever the right-pane visibility signal changes.
    this.rightPaneSub = this.uiService.showRightPane$.subscribe(() => this.cdRef.markForCheck());
  }

  ngAfterViewInit() {
    this.navService.initRightPaneChildNav(this.navCtrl, ChildNavNames.NotificationPageNavigation, PageName.GoAppNotificationPageComponent, false, { deviceString: this.device.deviceFlags.ios ? 'ios' : 'other' });
  }

  ngOnDestroy() {
    this.callback();
    if (this.rightPaneSub) this.rightPaneSub.unsubscribe();
    if (this.__source != 'menu') {
    this.navService.popChildNavCtrlFromStack(this.navService.getActiveChildNavName()).then(() => {
      if (this.navService.getActiveChildNavViewPageName() === PageName.NothingSelectedView) {
          this.uiService.showRightPane = false;
        }
      });
    }
  }

}
